const projects = [
  {
    id: 1,
    name: "INSPIRE CODE & GRAPHIC",
    type: "web",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "INSPIRE CODE & GRAPHIC is organize & managed by the INSPIRE team. The purpose and objective are to provide an extremely rich graphical user interface for creating & publishing a blog.",
    git_url: "https://www.github.com/guptaashwanee",
    technologies: ["React.js", "Node.js", "Firebase", "Github", "API"],
    front_image:
      "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-15%20151538.png",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-15%20151538.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20portfolio%20landing.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-13%20210929.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-13%20211125.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20about%20me.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20feature%202.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20profile.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20contact.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20services%202.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20profile%203.png",
      },
    ],
  },
  {
    id: 2,
    name: "TECHFEST SATI",
    type: "web",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "Techfest SATI is the annual fest of SATI Vidisha. A single page web app developed in React.js for multipurpose task and event management purpose.",
    git_url: "https://www.github.com/guptaashwanee",
    technologies: ["HTML", "CSS", "Javascript", "Jquery", "MDB", "Github"],
    front_image:
      "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Techfest%20SATI/Screenshot%202021-01-13%20204905.png",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Techfest%20SATI/Screenshot%202021-01-13%20204905.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Techfest%20SATI/Screenshot%202021-01-13%20204446.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Techfest%20SATI/Screenshot%202021-01-13%20205043.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Techfest%20SATI/Screenshot%202021-01-13%20204128.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Techfest%20SATI/Screenshot%202021-01-13%20205234.png",
      },
    ],
  },
  {
    id: 3,
    name: "PERSONAL WEBSITE V1",
    type: "web",
    web_url: "https://guptaashwanee.github.io/",
    description:
      "That is my first personal website that I design and publish through GitHub pages. Simple and elegant UI of the static HTML pages with CSS, JS, Bootstrap & Jquery technology.",
    git_url: "https://github.com/guptaashwanee/guptaashwanee.github.io",
    technologies: ["HTML", "CSS", "Javascript", "Jquery", "Bootstrap"],
    front_image:
      "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V1/Screenshot%202021-01-13%20203317.png",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V1/Screenshot%202021-01-13%20203317.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V1/Screenshot%202021-01-13%20203617.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V1/Screenshot%202021-01-15%20152651.png",
      },
    ],
  },
  {
    id: 4,
    name: "GRAPHICS",
    type: "graphic",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "Designed 500+ graphics, layouts (banners, posters, event themes, cards), Simple and elegant design that gives nice feel and look for viewers. I love to create beautiful stuffs.",
    git_url:
      "https://github.com/guptaashwanee/projects/tree/main/Graphic%20Design/graphics",
    technologies: ["COREL DRAW", "PHOTOSHOP", "ILLUSTRATOR"],
    front_image: "https://cdn.mos.cms.futurecdn.net/h5J594mu7Wh2NG4cYEyesj.png",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/Rudra%20Tattoo%20Zone.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/shaurabh.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/kesharwani%20auto%20parts%207x3.5%20NS%20%3D%201%20copy.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/fino%20payments%20bank.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/bal%20bharti%20school%20janakpur.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/bhawani%20electronics.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/graphics/mahadev%20general%20store.jpg",
      },
    ],
  },
  {
    id: 5,
    name: "LOGO",
    type: "graphic",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "I prefer logo design ahead of everything because it gives you to think more and more about it. Designed 50+ logos for local shops in brand development.",
    git_url:
      "https://github.com/guptaashwanee/projects/tree/main/Graphic%20Design/logo",
    technologies: ["COREL DRAW", "PHOTOSHOP", "ILLUSTRATOR"],
    front_image:
      "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/logo_face.jpg",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/VSSN%20logo.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/50818498_2224993011095612_3645776383549898752_o.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/korea%20mahila%20grih%20udyog.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/Inspire%20Graphics.jpg.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/Godwana%20School%20Logo.JPG",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/logo/flozum%20logo.jpg",
      },
    ],
  },
  {
    id: 6,
    name: "UI/UX DESIGN",
    type: "graphic",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "User interface design or user interface is the design of user interfaces for machines and software, such as computers, home appliances, mobile devices. Web Development is one of the core things.",
    git_url: "https://www.github.com/guptaashwanee",
    technologies: ["COREL DRAW", "PHOTOSHOP", "ILLUSTRATOR"],
    front_image:
      "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-15%20151538.png",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-15%20151538.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20portfolio%20landing.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-13%20210929.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/Screenshot%202021-01-13%20211125.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20about%20me.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20feature%202.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20profile.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20contact.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20services%202.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Web%20Development/Inspire%20Code%20%26%20Graphic%20V2/website%20profile%203.png",
      },
    ],
  },
  {
    id: 7,
    name: "SOCIAL MEDIA",
    type: "graphic",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "Social media design is visual content used in digital marketing. Whether it's your Facebook profile, Twitter background, Google+ header or graphics for timeline posts and blogs. Develop creative advertising content for various platforms while ensuring maximum brand a wareness of the target audience.",
    git_url:
      "https://github.com/guptaashwanee/projects/tree/main/Graphic%20Design/social%20media",
    technologies: ["COREL DRAW", "PHOTOSHOP", "ILLUSTRATOR"],
    front_image:
      "https://i2.wp.com/thembcgrp.com/wp-content/uploads/2020/10/Difference-between-Organic-and-Paid-in-Social-Media-1.jpg?fit=626%2C375&ssl=1",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/Screenshot%202021-01-15%20164703.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/Screenshot%202021-01-15%20164726.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/Screenshot%202021-01-15%20164750.png",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/55552000_2261250684136511_1997642551259037696_o.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/56870236_446264516124241_1608881120662974564_n.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/44417948_116183142629201_5927206888847441920_n.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/50740885_2295061107392145_5042464353383612416_o.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/social%20media/80892934_154558345963666_2876785581181996099_n.jpg",
      },
    ],
  },
  {
    id: 8,
    name: "BUSINESS CARDS | LETTER",
    type: "graphic",
    web_url: "https://inspire-graphics.web.app/",
    description:
      "Business cards are cards bearing business information about a company or individual. This is the very effective way of marketing for both eCommerce and non-eCommerce.",
    git_url:
      "https://github.com/guptaashwanee/projects/tree/main/Graphic%20Design/business%20card",
    technologies: ["COREL DRAW", "PHOTOSHOP", "ILLUSTRATOR"],
    front_image:
      "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/business-card.jpg",
    images: [
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/8.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/4.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/2.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/6.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/5.jpg",
      },
      {
        src:
          "https://raw.githubusercontent.com/guptaashwanee/projects/main/Graphic%20Design/business%20card/1.jpg",
      },
    ],
  },
];
const social = [
  {
    label: "facebook",
    link: "https://www.facebook.com/guptaashwanee",
    icon: "fab fa-facebook-f",
    anchorClass: "fb-ic",
  },
  {
    label: "twitter",
    link: "https://www.twitter.com/guptaashwanee",
    icon: "fab fa-twitter",
    anchorClass: "tw-ic",
  },
  {
    label: "github",
    link: "https://www.github.com/guptaashwanee",
    icon: "fab fa-github",
    anchorClass: "git-ic",
  },
  {
    label: "dribbble",
    link: "https://www.dribbble.com/guptaashwanee",
    icon: "fab fa-dribbble",
    anchorClass: "dribbble-ic",
  },
  {
    label: "linkedIn",
    link: "https://www.linkedin.com/in/guptaashwanee/",
    icon: "fab fa-linkedin-in",
    anchorClass: "li-ic",
  },
  {
    label: "instagram",
    link: "https://www.instagram.com/guptaashwanee",
    icon: "fab fa-instagram",
    anchorClass: "ins-ic",
  },
];

const getProject = () => {
  return projects;
};
const getSocialLinks = () => {
  return social;
};

export default {
  getProject,
  getSocialLinks,
};
